<template>
  <div>
    <div
      data-testid="bulk-dg-description"
      class="body1"
      v-html="
        $t(`modals.addToDataGovernancePermissions.bulkActionDescription`, {
          ...descriptionMetadata,
        })
      "
    />
    <div class="mt-3">
      <v-checkbox
        v-for="trigger in ticketActualTriggers"
        :key="trigger"
        :data-testid="`bulk-dg-trigger-${trigger}`"
        v-model="localValue.metadata.selectedSubEventTriggers"
        :value="trigger"
        :label="$t(`tickets.eventSubTriggers.${trigger}`)"
        hide-details
        :ripple="false"
      >
      </v-checkbox>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch, type PropType } from "vue";
import { useI18n } from "vue-i18n";
import { ViolationDirection } from "@/constants/tickets.ts";
import type { DialogDataConfig } from "@/_store/dialogs.module.ts";

export default defineComponent({
  props: {
    config: {
      type: Object as PropType<DialogDataConfig>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const i18n = useI18n();

    const ticketActualTriggers = computed(() => {
      return props?.config?.item?.sections?.aggregatedEventTriggers || [];
    });

    const descriptionMetadata = computed(() => {
      const violationValue =
        props?.config?.item?.sections?.userDataAccessViolation?.violationDirection ??
        ViolationDirection.SHARE;
      const violationDirection = i18n.t(`modals.addToDataGovernancePermissions.${violationValue}`);

      const violatedUsers = props?.config?.item?.sections?.userDataAccessViolation?.users ?? [];

      return {
        violationUsers: violatedUsers.join(", "),
        violationDirection,
        violationTrigger: `${i18n.t("general.dataTypes")}:`,
      };
    });

    const aggregatedEventTriggers = computed(() => {
      if (props?.config?.item?.sections?.aggregatedEventTriggers) {
        return [...props.config.item.sections.aggregatedEventTriggers];
      } else {
        return [];
      }
    });

    const localValue = ref({
      ...props.config,
      metadata: {
        selectedSubEventTriggers: aggregatedEventTriggers.value,
      },
    });

    watch(
      localValue.value,
      (newVal) => {
        emit("update:localValue", {
          ...newVal,
        });
      },
      { deep: true, immediate: true }
    );

    return {
      descriptionMetadata,
      ticketActualTriggers,
      localValue,
    };
  },
});
</script>

<style lang="scss" scoped></style>
